import * as React from 'react';
import Button from '@mui/material/Button';
import ButtonGroup from '@mui/material/ButtonGroup';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import Grow from '@mui/material/Grow';
import Paper from '@mui/material/Paper';
import Popper from '@mui/material/Popper';
import MenuItem from '@mui/material/MenuItem';
import MenuList from '@mui/material/MenuList';
import { Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';

export default function SplitButton({
  buttons: {
    buttonsNames: options,
    selectedButtonIndex,
    disabledButtons,
    dialogs,
  },
  handleClicks,
  classes,
  styleForSelectedButton,
  styleForDropdownButton,
  ids,
  buttonGroupStyle,
}) {
  const [open, setOpen] = React.useState(false);
  const anchorRef = React.useRef(null);
  const [selectedIndex, setSelectedIndex] = React.useState(selectedButtonIndex);
  const [openDialog, setOpenDialog] = React.useState(false);
  const [clickedButtonEvent, setClickedButtonEvent] = React.useState(null);

  let handleClick = handleClicks[selectedIndex];
  let id = ids?.[selectedIndex];
  let dialogOnSelectedIndex = dialogs?.[selectedIndex];
  let isDialog = dialogOnSelectedIndex ? true : false;

  const handleMenuItemClick = (event, index) => {
    setSelectedIndex(index);
    setOpen(false);
  };
  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const handleClose = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }

    setOpen(false);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
  }

  const handleDialogSubmit = () => {
    setOpenDialog(false);
    clickedButtonEvent && handleClick(clickedButtonEvent);
  }
  
  const handleFormSubmit = (event) => {
    if(isDialog){
      setOpenDialog(true);
      event && setClickedButtonEvent(event);
    }else{
      handleClick(event);
    }
  }

  return (
    <React.Fragment>
      <ButtonGroup style={{ ...buttonGroupStyle }} variant="contained" ref={anchorRef} aria-label="split button">
        <Button id={id} className={classes} style={{ ...styleForSelectedButton }} onClick={handleFormSubmit}>{options[selectedIndex]}</Button>
        <Button
          size="small"
          aria-controls={open ? 'split-button-menu' : undefined}
          aria-expanded={open ? 'true' : undefined}
          aria-label="select merge strategy"
          aria-haspopup="menu"
          onClick={handleToggle}
          style={{ ...styleForDropdownButton }}
        >
          <ArrowDropDownIcon />
        </Button>
      </ButtonGroup>
      <Popper
        sx={{
          zIndex: 1,
        }}
        open={open}
        anchorEl={anchorRef.current}
        role={undefined}
        transition
        disablePortal
      >
        {({ TransitionProps, placement }) => (
          <Grow
            {...TransitionProps}
            style={{
              transformOrigin:
                placement === 'bottom' ? 'center top' : 'center bottom',
            }}
          >
            <Paper>
              <ClickAwayListener onClickAway={handleClose}>
                <MenuList id="split-button-menu" autoFocusItem>
                  {options.map((option, index) => (
                    <MenuItem
                      key={option}
                      disabled={disabledButtons ? disabledButtons?.[index] : false}
                      selected={index === selectedIndex}
                      onClick={(event) => handleMenuItemClick(event, index)}
                    >
                      {option}
                    </MenuItem>
                  ))}
                </MenuList>
              </ClickAwayListener>
            </Paper>
          </Grow>
        )}
      </Popper>
      {isDialog && <Dialog open={openDialog} onClose={handleCloseDialog}>
        <DialogTitle>{dialogOnSelectedIndex?.dialogTitle}</DialogTitle>
        <DialogContent>
          {dialogOnSelectedIndex?.dialogContent}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDialog}>Cancel</Button>
          {
            dialogOnSelectedIndex?.submitDialogButtonName &&
            <Button onClick={handleDialogSubmit}>
              {dialogOnSelectedIndex?.submitDialogButtonName}
            </Button>
          }
        </DialogActions>
      </Dialog>}
      {/* <SnackBar snackBar={snackBar} setSnackBar={setSnackBar} /> */}
    </React.Fragment>
  );
}
